import { uuid } from '@tencent/midas-util';
export default uuid() + new Date().getTime();
